import React, { useContext, useEffect, useState } from "react";
import { Button, Modal, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Auth } from "../../Contexts/AuthContext";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import {
  BsFillGearFill,
  BsFillHouseDoorFill,
  BsMegaphoneFill,
  BsHeartFill,
} from "react-icons/bs";
import { FaPowerOff } from "react-icons/fa6";
const InfluencerMobileMenuList = () => {
  const { auth, logOut } = useContext(Auth);
  const [show, setShow] = useState(false);

  const handleLogout = () => {
    let config = {
      url: ApiUrl.brandLogout,
      method: "POST",
      body: {},
    };

    APIRequest(
      config,
      (res) => {
        logOut();
      },
      (err) => {
        logOut();
      }
    );
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);
  return (
    <div className="brand-Mobile-list-wrapper">
      <>
        <div className="user-avatar-box">
          <img src={auth.user?.avatar} alt="user" />
          <span className="title">{auth.user?.first_name}</span>
        </div>
        <div className="menu-list">
          <Link to="/influencer/dashboard" >
            <BsFillHouseDoorFill />
            Dashboard
          </Link>
          <Link to="/influencer/campaigns" >
            <BsMegaphoneFill />
            Campaigns
          </Link>
          <Link to="/influencer/wishlist" >
            <BsHeartFill />
            Wishlist
          </Link>
          <Link to="/influencer/account">
            <BsFillGearFill />
            Account
          </Link>
          <span onClick={handleShow}>
            <FaPowerOff />
            Sign Out
          </span>
        </div>

        <Modal
          show={show}
          onHide={handleClose}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="sign-out-modal"
        >
          <Modal.Body>
            <p className="sign-out-text">Are You Sure You Want To Log Out ?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose} className="no-btn">
              No
            </Button>
            <Button className="yes-btn" onClick={handleLogout}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </div>
  );
};

export default InfluencerMobileMenuList;
